<template>
    <div class="Home">
        <Carousel />
        <AboutUs :hideShowMoreBtn="true" />
        <ProductService />
        <News />
        <Partners :titleText="'合作伙伴'" :titleSubText="'PARTNERS'" />
        <ContactInfo />
    </div>
</template>

<script>
export default {
    components: {
        Carousel: () => import("../components/Home/Carousel"),
        AboutUs: () => import("../components/Home/AboutUs"),
        ProductService: () => import("../components/Home/ProductService"),
        News: () => import("../components/Home/News"),
        Partners: () => import("../components/Home/Partners"),
        ContactInfo: () => import("../components/Home/ContactInfo"),
    },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/views/Home.scss";
</style>

